/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./memetownIndex.vue?vue&type=template&id=3534d46c&scoped=true"
import script from "./memetownIndex.vue?vue&type=script&lang=js"
export * from "./memetownIndex.vue?vue&type=script&lang=js"
import style0 from "./memetownIndex.vue?vue&type=style&index=0&id=3534d46c&prod&lang=scss"
import style1 from "./memetownIndex.vue?vue&type=style&index=1&id=3534d46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534d46c",
  null
  
)

export default component.exports